/**
 * @fileoverview Kind of a placeholder right now until I figure out how exactly the content pane works.
 */

import { elt, removeAllChildren } from './dom';
import { ContentSection } from './AppState';
import { Placeholder } from './components/placeholder';

export class RebuildContentPane extends HTMLElement {
  placeholder: Placeholder;

  connectedCallback() {
    this.placeholder = Placeholder.createElement();
    this.append(this.placeholder);
  }

  setActivity(activity: ContentSection): void {
    this.placeholder.setAttribute('title', ContentSection[activity]);
    if (!this.placeholder.isConnected) {
      removeAllChildren(this);
      this.append(this.placeholder);
    }
  }

  setContent(contentPane: HTMLElement) {
    removeAllChildren(this);
    this.append(contentPane);
  }
}
